import { slugify } from '@bridebook/toolbox/src';
import { A, Box } from '@bridebook/ui';
import componentStyles from './index.style';

interface IProps {
  title: string;
  urlHref: string;
  urlAs?: string;
}

const SearchSectionBlockItem = ({ title, urlHref }: IProps) => {
  const styles = componentStyles();

  return (
    <Box style={styles.searchItemWrap} key={`search-section-block-seo-${slugify(title)}`}>
      <A noUnderline href={urlHref} style={styles.searchItem}>
        {title}
      </A>
    </Box>
  );
};

export default SearchSectionBlockItem;
